import "../assets/styles/components/pill-card.scss";
import Document from "../assets/icons/document";
import ArrowRightLight from "../assets/icons/arrow-right-light";
import CheckRounded from "../assets/icons/check-rounded";
import Play from "../assets/icons/play";
import Edit from "../assets/icons/edit";
import Clock from "../assets/icons/clock";
import { useEffect, useState } from "react";
import Boxes from "../assets/icons/boxes";
import Star from "../assets/icons/star";
import { detectIncognito } from "detectincognitojs";

export default function PillCard({
  pill_info,
  setCurrentPill = null,
  container_info = null,
  context,
  setContext,
}) {
  const [complete, setComplete] = useState(false);

  useEffect(() => {
    if (context?.progress && pill_info?.assetIdentifier) {
      let pill_progress = context.progress.find(
        (x) => x.cmId.toString() === pill_info.assetIdentifier
      );
      setComplete(pill_progress && pill_progress?.state > 0);
    }
  }, [context.progress]);

  if (pill_info) {
    const time =
      pill_info.duration >= 60 ? Math.floor(pill_info.duration / 60) : 1;
    const icons = {
      documento: <Document size={30} color="#ffffff" />,
      video: <Play size={45} color="#ffffff" />,
      esercitazione: <Edit size={24} color="#ffffff" />,
      "feedback survey": <Star size={28} color="#ffffff" />,
      scorm: <Boxes size={26} color="#ffffff" />,
    };

    const is_feature_pill =
      new Date(pill_info.publishDate) > new Date() || false;

    const handleClick = async () => {
      const is_incognito = await detectIncognito().then((result) => {
        return result.isPrivate;
      });

      if (pill_info?.assetIdentifier) {
        const open_on_external_window =
          context.browser === "safari" ||
          context.device === "mb" ||
          pill_info?.type?.assetResourceType !== "VIDEO" ||
          is_incognito;

        let path_extension = null;

        if (pill_info?.type?.assetResourceType) {
          switch (pill_info.type.assetResourceType) {
            case "QUIZ":
              path_extension = "quiz";
              break;
            case "FEEDBACK":
              path_extension = "feedback";
              break;
            case "SCORM":
              path_extension = "scorm";
              break;
            default:
              path_extension = "resource";
              break;
          }
        }

        const url = `${
          process.env.REACT_APP_MOODLE_BASE_URL
        }/q8auth/q8_sso.php?client_id=${
          process.env.REACT_APP_SSO_CLIENT_ID
        }&dest=${encodeURIComponent(
          `/mod/${path_extension}/view.php?id=${pill_info.assetIdentifier}`
        )}&back_link=`;

        if (setCurrentPill) {
          if (!open_on_external_window) setCurrentPill(pill_info);
          else {
            localStorage.setItem("last_container_viewed", container_info.id);
            if (path_extension !== "scorm") {
              window.onbeforeunload = function () {};
            }
            setContext({ loader_pills: true });
            document.location.href = url;
          }
        } else {
          let total_time_count = 0;
          container_info.learningPills.map((item) => {
            total_time_count +=
              item.duration >= 60
                ? Math.floor(item.duration / 60)
                : item.duration > 0
                ? 1
                : 0;
          });
          if (open_on_external_window) {
            localStorage.setItem("last_container_viewed", container_info.id);
          }
          // context.navigateUrl("/pills-list", {
          //   state: {
          //     ...container_info,
          //     ...{
          //       total_time: total_time_count,
          //       selected: !open_on_external_window ? pill_info : null,
          //     },
          //   },
          // });
          if (open_on_external_window) {
            if (path_extension !== "scorm") {
              window.onbeforeunload = function () {};
            }
            setContext({ loader_pills: true });
            document.location.href = url;
          }
          context.updateUserProgress(context);
        }
      } else context.openMessage("warning", "Contenuto non disponibile");
    };

    return (
      <div
        onClick={() => handleClick()}
        className={`pill-card ${
          pill_info?.assetIdentifier ? "" : "pill-disabled"
        } w-100 mx-md-auto px-3 d-flex border-bottom align-items-center position-relative py-4`}
      >
        <div
          className={`d-flex align-items-center w-100 ${
            is_feature_pill ? "inactive" : ""
          }`}
        >
          <div className="pill-card__file-type d-flex align-items-center justify-content-center position-relative">
            {complete ? (
              <div className="compleate position-absolute d-flex justify-content-center align-items-center">
                <div className="background position-absolute"></div>
                <CheckRounded size={24} color="#9fb833" />
              </div>
            ) : null}
            {icons[pill_info.type.name.toLowerCase()]}
          </div>
          <div className="d-flex flex-wrap align-items-center w-100 ms-3">
            {pill_info?.isGestore &&
            context?.session?.profileTypeCode &&
            ["ADMIN", "DM", "AM", "RCR"].includes(
              context?.session?.profileTypeCode
            ) ? (
              <small className="manager-content-label mb-1">
                Disponibile per i gestori
              </small>
            ) : null}
            <span className="card-name d-block w-100 mb-2">
              {pill_info.title}
            </span>
            {pill_info.assetIdentifier ? (
              <span className="extra-info d-flex align-items-center">
                <Clock className="me-1" size={16} color="#20419a" />
                {pill_info.duration > 60 ? time : 1}
                {` minut${time === 1 ? "o" : "i"}`}
              </span>
            ) : (
              <small>Contenuto non disponibile</small>
            )}
            {pill_info.isNew && !complete ? (
              <small className="new-content ms-auto">Nuovo contenuto!</small>
            ) : null}
          </div>

          <ArrowRightLight size={20} color="#a0a0a0" className="ms-3" />
        </div>
      </div>
    );
  }
}
